/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsBookingParallelInput } from "../../entities/models/BookingParallelInput";
import { z } from "zod/v4";

export const modelsBookingParallelInputSchema = z.object({
    "child_barber_id": z.optional(z.int()),
"child_emoji": z.optional(z.string()),
"child_service_id": z.int(),
"child_start_time": z.optional(z.string()),
"parent_barber_id": z.optional(z.int()),
"parent_emoji": z.optional(z.string()),
"parent_service_id": z.int(),
"parent_start_time": z.optional(z.string()),
"scheduled_start_time": z.string(),
"user_id": z.string()
    }) as unknown as z.ZodType<ModelsBookingParallelInput>